var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666016 10.4758V13.5411C0.666016 14.9053 3.93247 16 7.97747 16C12.0225 16 15.2889 14.9053 15.2889 13.5411V10.4758C13.5457 11.5706 10.6177 12.0085 7.97747 12.0085C5.33722 12.0085 2.40926 11.5706 0.666016 10.4758Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97747 6.46744C5.33722 6.46744 2.40926 6.02955 0.666016 4.91797V8.00007C0.666016 9.34744 3.93247 10.4422 7.97747 10.4422C12.0225 10.4422 15.2889 9.34744 15.2889 7.98323V4.91797C13.5457 6.02955 10.6177 6.46744 7.97747 6.46744Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97747 4.91789C12.0155 4.91789 15.2889 3.81698 15.2889 2.45895C15.2889 1.10091 12.0155 0 7.97747 0C3.93946 0 0.666016 1.10091 0.666016 2.45895C0.666016 3.81698 3.93946 4.91789 7.97747 4.91789Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataWhiteIcon);
export default __webpack_public_path__ + "static/media/DataWhiteIcon.316af3f7.svg";
export { ForwardRef as ReactComponent };